// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n9u5","toggleWrap":"styles_toggleWrap__3Mf8D","content":"styles_content__2oDcx","selectAreaCode":"styles_selectAreaCode__3eCiJ"};